/** Natural, case- and number-aware string compare: "LVL2" sorts before "LVL10",
 *  "BLKA.2" before "BLKA.10", and case is ignored. The app's default for sorting
 *  human-facing labels (zones, levels, work-code names). */
export function naturalCompare(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
}
